<template>
  <div class="sub_detail">
    <header class="n-fixed-top bg-c bColor" v-if="is_webview == 0">
      <div class="left" v-if="$route.name !== 'index'" @click="back()">
        <div class="n-back"></div>
      </div>
      <h4>
        <span>{{ $t("sub_index.tit_report") }}</span>
      </h4>
      <div class="right" v-if="$route.name !== 'index'"></div>
    </header>
    <div class="sr_con">
      <div class="logo">
        <img :src="company.logo ? company.logo : defaultHeadImg" alt="" />
      </div>
      <div class="sr_tit">{{ user_survey.resources_name }}</div>
      <div class="sr_des sr_name">
        {{ $t("sub_report.name") }} <span> {{ user.username }}</span>
      </div>
      <div class="sr_des sr_time">
        {{ $t("sub_report.time") }} <span>{{ user_survey.submit_date }} </span>
      </div>
      <div
        class="sr_des"
        v-for="(item, index) in user_survey.survey_question"
        :key="index"
      >
        <p v-if="item.question_type == 5">
          {{ index + 1 }}. {{ item.question_title }}
        </p>
        <p v-html="$xss(item.question_content)"></p>
        <div class="sr_des_con" v-if="item.question_type == 5">
          {{ item.answer }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import defaultHeadImg from "@/assets/img/new/logo.png";
export default {
  data() {
    return {
      titleValue: this.$t("sub_report.case"),
      defaultHeadImg: defaultHeadImg,
      trainplan_id: "",
      resources_id: "",
      my_sub_id: "", // 用户id
      subreflectDetailData: [], // 下属案例详情列表数据
      company: {}, // 公司数据
      user: {}, // 用户数据
      user_survey: {}, // 用户数据
      is_webview: 0, // 0 ：h5, 1:安卓iOS
    };
  },
  mounted() {
    //  document.title=this.$t("sub_index.tit_report");
    this.$nextTick(() => {
      this.getSubReflectDetailDate();
    });
  },
  methods: {
    getSubReflectDetailDate() {
      var _this = this;
      let url = "index.php/mobile/user-follow-up/sub-reflection-detail";

      let webview = {},
        params = {};
      window.location.hash
        .split("?")[1]
        .split("&")
        .forEach((e) => {
          let arr0 = e.split("=")[0];
          let arr1 = e.split("=")[1];
          webview[arr0] = arr1;
        });
      if (webview.is_webview == 1) {
        this.is_webview = 1;
        params = webview;
      } else {
        this.trainplan_id = this.$route.query.trainplan_id;
        this.resources_id = this.$route.query.resources_id;
        this.my_sub_id = this.$route.query.my_sub_id;

        params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),

          page: 1,
          size: 10,
          study_status: 0,
          trainplan_id: this.trainplan_id,
          resources_id: this.resources_id,
          sub_user_id: this.my_sub_id,
        };
      }

      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          _this.subreflectDetailData = res.data.result;
          _this.company = res.data.result.company;
          _this.user = res.data.result.user;
          _this.user_survey = res.data.result.user_survey;
          // console.log(_this.subreflectDetailData)
        }
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_detail {
  background-color: #eee;
  min-height: 100vh;
  overflow: auto;
  .sr_con {
    margin: 0.32rem;
    min-height: calc(100% - 1.36rem);
    padding: 0.26rem 0.2rem;
    box-sizing: border-box;
    background-color: #fff;
    font-size: 0.22rem;
    color: #252631;
    border-radius: 0.1rem;
    .logo {
      img {
        width: 1.78rem;
        height: 0.4rem;
      }
    }
    .sr_tit {
      font-size: 0.26rem;
      margin-top: 0.34rem;
      margin-bottom: 0.58rem;
      text-align: center;
    }
    .sr_des {
      span {
        display: inline-block;
        width: 5rem;
        color: #7f8485;
        border-bottom: 0.02rem solid #dedede;
        vertical-align: top;
        margin-left: 0.1rem;
      }
      p {
        margin-bottom: 0.2rem;
      }
      .sr_des_con {
        width: 6.1rem;
        min-height: 0.4rem;
        border: 1px solid rgba(216, 216, 216, 0.85);
        border-radius: 0.04rem;
        margin-bottom: 0.32rem;
        padding: 0.2rem;
        color: #7f8485;
      }
    }
    .sr_name {
      margin-top: 0.58rem;
    }
    .sr_time {
      margin-top: 0.1rem;
      margin-bottom: 0.6rem;
    }
    .sr_que {
      margin-top: 0.6rem;
      margin-bottom: 0.3rem;
    }
  }
}
</style>
